import React from "react";
import { ConfirmationModal } from "@folio/stripes/components";
import { useIntl } from "react-intl";
export var ProductPublishingDateRequiredModal = function (_a) {
    var open = _a.open, onEdit = _a.onEdit, onCancel = _a.onCancel;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(ConfirmationModal, { open: open, heading: formatMessage({
            id: "ui-br-agency.product.makePublic.publishingDate.required.heading",
        }), message: formatMessage({
            id: "ui-br-agency.product.makePublic.publishingDate.required.message",
        }), onConfirm: onEdit, onCancel: onCancel, confirmLabel: formatMessage({
            id: "ui-br-agency.button.editProduct",
        }), cancelLabel: formatMessage({
            id: "ui-br-agency.button.cancel",
        }), buttonStyle: "primary" }));
};
